import { css } from '@emotion/react';
import { ToucanComponents } from '@jointoucan/toucan-design';
import { useTheme } from '@mui/material';
import { GetServerSideProps } from 'next';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';

import FormPageContainer from '~/components/shared/FormPageContainer';
import Layout from '~/components/shared/Layout';
import AnimationOrImage from '~/components/shared/UserAccount/AnimationOrImage';
import ForgotPasswordForm from '~/components/shared/forms/ForgotPassword';
import Errors from '~/helpers/errors';
import { getTranslations } from '~/lib/next-i18next';

import laptopAnimation from '#animations/onboarding/icon-laptop.json';

const { Typography, Button, ToucanIcon } = ToucanComponents;

const ForgotPassword = () => {
  const theme = useTheme();
  const { t } = useTranslation('forgot-password');
  const router = useRouter();

  return (
    <Layout pageError={Errors.ForgotPasswordPageError}>
      <FormPageContainer>
        <AnimationOrImage
          lottieAnimation={laptopAnimation}
          css={css`
            margin-bottom: ${theme.spacing(2)};
          `}
        />{' '}
        <ForgotPasswordForm />
        <Typography
          variant="xs"
          css={css`
            text-align: center;
          `}
        >
          <Button
            type="text"
            onClick={() => {
              router.push('/log-in');
            }}
            css={css`
              display: inline-flex;
              margin-top: ${theme.spacing(3)};
            `}
          >
            <ToucanIcon
              icon="chevron-left"
              css={css`
                color: inherit;
                width: 12px;
                height: 12px;
                margin-right: ${theme.spacing(0.5)};
              `}
            />
            {t('sharedBackButton')}
          </Button>
        </Typography>
      </FormPageContainer>
    </Layout>
  );
};

export default ForgotPassword;

export const getServerSideProps: GetServerSideProps = async ({ locale }) => ({
  props: {
    ...(await getTranslations({
      locale,
      namespaces: 'forgot-password',
    })),
  },
});
